function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.1327273 2.9564545 3.5945455 1.4073636C0 4.9779091 0 7.5655455 0 10.909182h1.0909091l1.0909091-.06873c0-3.1941823 0-4.9538186 2.9509091-7.8840005zM20.404364 1.4073636l-1.536 1.5490909c2.949818 2.9301819 2.949818 4.6898182 2.949818 7.9527275L24 10.840452c0-3.2749095 0-5.8625459-3.595636-9.4330914ZM12 22.909182a3.2509091 3.2509091 0 0 0 3.074182-2.181818H8.9258182A3.2509091 3.2509091 0 0 0 12 22.909182Zm7.636364-8.088V9.818273c0-3.5094548-2.383637-6.4658185-5.612728-7.3549094C13.704 1.6582727 12.922909 1.091 12 1.091c-.922909 0-1.704.5672727-2.023636 1.3723636-3.2301822.8890909-5.6127276 3.8454546-5.6127276 7.3549094v5.002909l-1.8621819 1.862182a1.0865455 1.0865455 0 0 0-.3196363.771272v1.090909a1.0909091 1.0909091 0 0 0 1.0909091 1.09091H20.727273a1.0909091 1.0909091 0 0 0 1.090909-1.09091v-1.090909a1.0865455 1.0865455 0 0 0-.319637-.771272z",
    style: {
      fill: "var(--primary-color)",
      strokeWidth: 1.09091,
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13c-2.76116 0-5 2.23884-5 5s2.23884 5 5 5 5-2.23884 5-5-2.23884-5-5-5z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      strokeWidth: 0.0223214
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 13c-2.76116 0-5 2.23884-5 5s2.23884 5 5 5 5-2.23884 5-5-2.23884-5-5-5zm2.41741 6.68527c.0335.0335.0513.0781.0513.125s-.018.0937-.0513.125l-.48214.48437c-.0357.0357-.0804.0513-.125.0513s-.0915-.0178-.125-.0513L18 18.73214l-1.68304 1.68974c-.0335.0357-.0804.0513-.125.0513s-.0915-.0178-.125-.0513l-.48214-.48438c-.0335-.0335-.0513-.0781-.0513-.125s.0178-.0937.0513-.125l1.68973-1.69643-1.69419-1.67411c-.0692-.0692-.0692-.18304 0-.25223l.48214-.48437c.0335-.0335.0781-.0513.125-.0513s.0915.0178.125.0513l1.68973 1.66741 1.68973-1.66741c.0335-.0335.0781-.0513.125-.0513s.0915.0178.125.0513l.48215.48437c.0692.0692.0692.18304 0 .25223l-1.6942 1.67411z",
    style: {
      fill: "#c84040",
      fillOpacity: 1,
      strokeWidth: 0.0223214
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellDisabled);
export default __webpack_public_path__ + "static/media/bell-disabled.f3afa90d7324b3d7bdf7084ea9b35e48.svg";
export { ForwardRef as ReactComponent };